// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"ef640441","239":"e39fb35b","455":"a158387b","484":"14cb0921","551":"c2ddb01f","690":"2442f6cc","857":"44f4b707","977":"279b6d75"}[chunkId] + ".chunk.js";
};